angular
    .module('empower.control')
    .directive("textareacount", function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var textlimit = element[0].maxLength - element[0].value.length;
                var parent = $(element).parent();
                parent.addClass('textlimit-container');
                var label = $('<label>');
                label.insertAfter(element);
                label.addClass('textlimit')
                label.text(textlimit);
                scope.$watch(attrs.ngModel, function () {
                    textlimit = element[0].maxLength - element[0].value.length;
                    label.text(textlimit);
                })
                
            } // link
        };
    })